import {Component, input} from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    standalone: true,
    styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  grow = input<boolean>(false)
  small = input<boolean>(false)
}
